// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as _env from "../assets/config/config.uat.json";
let conf: any = _env.default;
export const environment = {
  name: "uat",
  appName: conf.env.appName,
  production: conf.env.isProduction,
  version: conf.env.appVersion,
  hostUrl: conf.apiServer.APIurl,
  socketUrl: conf.apiServer.socketUrl,
  port: conf.apiServer.port,
  portalUrl: conf.portalSwitch.portalUrl
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
